import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import PnlBreakdownGetter from "../../../../getters/pnlBreakdownGetter/PnlBreakdownGetter";
import { useAtom } from "jotai";
import { useRef } from "react";
import { lastNMonthDataAtom } from "reports/store/store";
import { useFetchCustomerTimezone } from "reports/utils/customerInfoUtils";
import { getEpochTime } from "../bespokeReportUtils";
import LoadingCircle from "reports/components/simple/LoadingCircle";

export default function LastNMonthGetter({
  numMonths,
  machemetryIds,
}: {
  numMonths: number;
  machemetryIds: string[];
}) {
  const timeZone = useFetchCustomerTimezone();
  const now = useRef(new Date()).current;

  const [, setLastNMonthData] = useAtom(lastNMonthDataAtom);

  if (timeZone) {
    const lastNMonthsTimeRanges = getLastNMonthsTimeRanges({
      now,
      timeZone,
      numMonths,
    });
    return (
      <>
        {lastNMonthsTimeRanges.map(({ ge, lt }, index) => {
          return (
            <PnlBreakdownGetter
              key={ge}
              range={{ ge, lt }}
              machemetryIds={machemetryIds}
              setPnlBreakdownData={setLastNMonthData}
              multiData={true}
            />
          );
        })}
      </>
    );
  }

  return <LoadingCircle />;
}

/** Month starts on first day of Month at 12 am and ends on last day of Month at 23:59:59
 *
 * Month start :  https://date-fns.org/v2.22.1/docs/startOfMonth
 *
 *  Month end :  https://date-fns.org/v2.22.1/docs/endOfMonth* *
 */
export function getLastNMonthsTimeRanges({
  now,
  timeZone,
  numMonths,
}: {
  now: Date;
  timeZone: string;
  numMonths: number;
}) {
  const startDayOfMonth = startOfMonth(now);
  const endDayOfMonth = endOfMonth(now);

  const lastNMonthsTimeRanges = [...Array(numMonths)].map((_, index) => {
    const ge = getEpochTime({
      timeZone,
      baselineDate: subMonths(startDayOfMonth, index + 1),
    });

    //by default the hours , minutes and seconds are 0
    // need to set the hours, mins, and seconds to 23:59:59 so as to not loose 1 day of data
    const lt = getEpochTime({
      timeZone,
      baselineDate: subMonths(endDayOfMonth, index + 1),
      hour: 23,
      minute: 59,
      seconds: 59,
    });
    return { ge, lt };
  });
  return lastNMonthsTimeRanges;
}
